export default "__VITE_ASSET__27da212e__"